import { AuthContext } from '@/store/auth/auth.store';
import type { AuthContextValue } from '@/store/auth/auth.types';
import { useContext } from 'react';

export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
